import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { FacilitySearchResult } from '../models/facility-search-result.model';
import { MatchGroupPermissions } from '../models/match-group-permissions.model';
import { MatchGroupsResponse } from '../models/match-group.model';

/**
 * @deprecated Do not use this service.  Use service(s) from "src/app/compliance/api" or "src/app/compliance/api/migration"
 */
@Injectable({ providedIn: 'root' })
export class MatchGroupService {
    private readonly coreApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) readonly settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    // ** ComplianceController.GetComplianceGroup
    loadMatchGroups(): Observable<MatchGroupsResponse> {
        return this.http.get<MatchGroupsResponse>(`${this.coreApiPath}/compliance/Groups`);
    }

    // ** ComplianceController.GetFacilitiesAndSystems
    loadFacilities(type: string, name: string): Observable<FacilitySearchResult> {
        return this.http.get<FacilitySearchResult>(`${this.coreApiPath}/compliance/${type}/${name}`);
    }

    // ** ComplianceController.CreateGroup
    createGroup(name: string, facilityIds: number[], systemIds: number[]): Observable<unknown> {
        return this.http.post(`${this.coreApiPath}/compliance/Group/${name}`, {
            facilityIds: facilityIds,
            systemIds: systemIds
        });
    }

    // ** ComplianceController.UpdateGroup
    updateGroup(
        id: number,
        name: string,
        facilityIds: number[],
        systemIds: number[],
        isStrike: boolean
    ): Observable<unknown> {
        return this.http.patch(`${this.coreApiPath}/compliance/Group/${id}`, {
            groupName: name,
            facilityIds: facilityIds,
            systemIds: systemIds,
            isStrike
        });
    }

    // ** ComplianceController.DeleteGroupItem
    deleteGroupItem(facilityId: number, groupId: number, isStrike: boolean): Observable<unknown> {
        return this.http.delete(`${this.coreApiPath}/compliance/Group/${facilityId}/${groupId}/${isStrike}`);
    }

    // ** ComplianceController.DeleteGroup
    deleteGroup(groupId: number): Observable<unknown> {
        return this.http.delete(`${this.coreApiPath}/compliance/Group/${groupId}`);
    }

    // ** ComplianceController.GetComplianceGroupPermissions
    getPermissions(): Observable<MatchGroupPermissions> {
        return this.http.get<MatchGroupPermissions>(`${this.coreApiPath}/compliance/Groups-Permissions`);
    }
}
